import './index.css';
import { bootstrap } from './app/bootstrap';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('Missing #root element in index.html');
}

void bootstrap(container, import.meta.env, async () => {
  const { default: App } = await import('./app/App');
  return App;
});
